var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePicSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Essentials/photo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.00559 8C3 8.41261 3 8.87562 3 9.4V14.6C3 16.8402 3 17.9603 3.43597 18.816C3.81947 19.5686 4.43139 20.1805 5.18404 20.564C6.03968 21 7.15979 21 9.4 21H14.6C15.1244 21 15.5874 21 16 20.9944M3.00559 8C3.02389 6.6499 3.10205 5.8394 3.43597 5.18404C3.81947 4.43139 4.43139 3.81947 5.18404 3.43597C6.03968 3 7.15979 3 9.4 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03968 21 7.15979 21 9.4V14.6C21 16.1138 21 17.1162 20.8655 17.8711M3.00559 8L8.00559 13M16 20.9944C17.3501 20.9761 18.1606 20.8979 18.816 20.564C19.5686 20.1805 20.1805 19.5686 20.564 18.816C20.7054 18.5385 20.8009 18.2333 20.8655 17.8711M16 20.9944L8.00559 13M8.00559 13L9.73726 11.2683C10.5293 10.4763 10.9253 10.0803 11.382 9.93191C11.7837 9.80139 12.2163 9.80139 12.618 9.93191C13.0747 10.0803 13.4707 10.4763 14.2627 11.2683L20.8655 17.8711M17.01 7H16.99",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicSvg);
export default __webpack_public_path__ + "static/media/profile_pic_svg.c3b1cc7efc4bf5a602c8dde55f8a749d.svg";
export { ForwardRef as ReactComponent };